import type { AxiosError } from 'axios';

/** Shape of the BE error envelope (`ApiResponse<Void>`) for digital-checkin endpoints. */
export interface ApiErrorEnvelope {
  status?: number;
  message?: string;
  errorCode?: string;
  success?: boolean;
}

/**
 * Pulls a user-safe message out of an axios error.
 *
 * Reads `response.data.message` from the BE envelope; falls back to the supplied
 * default when the BE didn't send one (or sent only whitespace).
 */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  const e = err as AxiosError<ApiErrorEnvelope>;
  const message = e?.response?.data?.message;
  return (message && message.trim()) || fallback;
}

/**
 * Stable, machine-readable error code from the BE envelope (e.g.
 * `WORKFLOW_NOT_CREATED`, `HEALTH_HISTORY_STEP_NOT_FOUND`). Use this to branch
 * on specific error conditions instead of matching on message text.
 */
export function getApiErrorCode(err: unknown): string | undefined {
  const e = err as AxiosError<ApiErrorEnvelope>;
  return e?.response?.data?.errorCode;
}
